// Små länk-hjälpare för SFS-nummer. Ligger i en egen, lätt modul så att
// serverfunktioner och kommun-källor inte drar in hela lagtaxonomin.
export function rd(sfs: string) {
  const norm = sfs.replace(":", "-");
  return `https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/_sfs-${norm}/`;
}

// SFS-nummer med icke-standardiserade riksdagen.se-URL:er (t.ex. mellanslag i SFS).
const SFS_URL_OVERRIDES: Record<string, string> = {
  "1736:0123 2":
    "https://www.riksdagen.se/sv/dokument-och-lagar/dokument/svensk-forfattningssamling/handelsbalk-17360123-2_sfs-1736-0123%202/",
};

export function lawUrl(sfs: string): string {
  return SFS_URL_OVERRIDES[sfs] ?? rd(sfs);
}
